import React from 'react';
import styled from 'styled-components';

import colors from 'utils/colors';

import Tick from '../Icons/Tick';
import Text from '../Text';

const ThankWapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 2px solid ${colors.green};
  max-width: 160px;
  height: 50px;

  span {
    color: ${colors.green};
  }
`;

const TickWrapper: React.FC = styled.div`
  svg {
    width: 20px;
    height: 20px;
    margin-top: 2px;
    margin-right: 10px;
  }
`;

const ThankYou: React.FC<{ text: string }> = ({ text = 'Thank you' }) => {
  return (
    <ThankWapper>
      <TickWrapper>
        <Tick />
      </TickWrapper>
      <Text.Body fontWeight='bold' as='span'>
        {text}
      </Text.Body>
    </ThankWapper>
  );
};

export default ThankYou;
